// import Results from "./Results";
// import FastResults from "./FastResults";
// import IndividualResult from "./IndividualResult/index";

import lazyImport from "../../../utils/lazyImport/lazyImport";

// lazyImport the above imports
const Results = lazyImport(() => import("./Results"));
const FastResults = lazyImport(() => import("./FastResults"));
const IndividualResult = lazyImport(
  () => import("./IndividualResult/IndividualResult")
);

export default {
  Results,
  FastResults,
  IndividualResult,
};
